import { Box, LinearProgress, Typography } from '@mui/material';
import { Vocabulary } from '../Utils/Vocabulary';

const STEP_COUNT = 4;

interface Props {
  activeStep: number;
}

export default function WizardProgressBar({ activeStep }: Props) {
  const progress = ((activeStep + 1) / STEP_COUNT) * 100;

  return (
    <Box sx={{ py: 3, px: 2 }}>
      <Typography variant="body2" color="text.secondary" gutterBottom>
        {Vocabulary.stepOf(activeStep + 1, STEP_COUNT)}
      </Typography>
      <LinearProgress variant="determinate" value={progress} color="primary" />
    </Box>
  );
}
